import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../I18n';
import {Button} from 'rctui';

class KeyValue extends React.Component {
  static defaultProps = {
    disabled: false,
    name: '',
    value: ''
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  };

  delimiter = ',';

  constructor(props) {
    super(props);
    let typeIsString = typeof this.props.value === 'string';
    let value = {};

    if (typeIsString) {
      let list = this.props.value.split(this.delimiter);
      if (list.length > 1) {
        for (let i = 0; i < list.length; i += 2) {
          value[list[i]] = list[i + 1];
        }
      }
    } else {
      value = Object.assign({}, this.props.value);
    }

    this.state = {
      value: value,
      typeIsString: typeIsString
    };
    this.inputRefs = {};
    this.onSave = this.onSave.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }

  getInputRef(name) {
    if (!this.inputRefs[name]) {
      this.inputRefs[name] = React.createRef();
    }
    return this.inputRefs[name];
  }

  onSave(key) {
    let stateValue = Object.assign({}, this.state.value);
    let nodeKey = this.getInputRef(key + "-key").current;
    let nodeValue = this.getInputRef(key + "-value").current;
    let newKey = nodeKey.value;
    let newValue = nodeValue.value;

    if (key === 'add') {
      nodeKey.value = '';
      nodeValue.value = '';
    }

    if (stateValue[key] !== undefined && key != newKey) {
      delete stateValue[key];
    }

    stateValue[newKey] = newValue;
    this.setValue(stateValue);
  }

  onDelete(key) {
    let value = Object.assign({}, this.state.value);

    delete value[key];

    this.setValue(value);
  }

  setValue(value) {
    this.setState({
      value: value
    });

    let nextValue = value;
    if (this.state.typeIsString) {
      let origin = nextValue;
      nextValue = [];
      for (let key in origin) {
        nextValue.push(key);
        nextValue.push(origin[key]);
      }
      nextValue = nextValue.join(this.delimiter);
    }

    this.props.onChange && this.props.onChange(this.props.name, nextValue);
  }

  render() {
    let items = [];
    for (let key in this.state.value) {
      items.push(<tr key={key}>
        <td><input defaultValue={key} ref={this.getInputRef(key + "-key")}/></td>
        <td><input defaultValue={this.state.value[key]} ref={this.getInputRef(key + "-value")}/></td>
        <td>
          <Button onClick={this.onSave.bind(this, key)}><I18n message="button.save"/></Button>
        </td>
        <td>
          <Button onClick={this.onDelete.bind(this, key)}><I18n message="button.delete"/></Button>
        </td>
      </tr>);
    }
    return (
      <table className="key_value">
        <thead>
        <tr>
          <th><I18n message="form.key_value.key"/></th>
          <th><I18n message="form.key_value.value"/></th>
          <th colSpan="2"></th>
        </tr>
        </thead>
        <tbody>
        {items}
        <tr>
          <td><input defaultValue="" ref={this.getInputRef("add-key")}/></td>
          <td><input defaultValue="" ref={this.getInputRef("add-value")}/></td>
          <td colSpan="2">
            <Button onClick={this.onSave.bind(this, 'add')}><I18n message="button.add"/></Button>
          </td>
        </tr>
        </tbody>
      </table>
    );
  }
}

export default KeyValue;



// WEBPACK FOOTER //
// ./src/js/Component/Form/KeyValue/Main.jsx